// Move Firefly between the floating tab and the notification bell.
import { useFireflyDisplayMode } from "@/hooks/useFireflyDisplayMode";
import { dockFireflyInSidebar, returnFireflyToFloating } from "@/lib/firefly/sidebarFireflyDockActions";

export function DockFireflyInSidebarButton({ onAfterDock }: { onAfterDock?: () => void }) {
  const { mode } = useFireflyDisplayMode();
  const docked = mode === "docked";

  return (
    <button
      type="button"
      onClick={() => {
        if (docked) returnFireflyToFloating();
        else dockFireflyInSidebar();
        onAfterDock?.();
      }}
      className="rounded-full border border-emerald-300 bg-emerald-50 px-2.5 py-1 text-[11px] font-semibold text-emerald-900 hover:bg-emerald-100 dark:border-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-100 dark:hover:bg-emerald-950/70"
    >
      {docked ? "Float Firefly" : "Dock in bell"}
    </button>
  );
}
